/* EB cart funnel rail — LIVE + Funnel Build 2026-10-20, fix pass 2026-10-20.
   Renders the "Complete the Set" sibling rail inside the ajax cart drawer:
   the FULL sibling family (root part number grouping) of EVERY cart item -
   union across items, deduped - each card with its own choose-both
   quick-add that posts straight to the cart from inside the drawer.
   Placement contract: the [data-eb-funnel] container lives INSIDE
   .ajax-cart__list in templates/cart.ajax.liquid, ABOVE the line items,
   because the theme's jsAjaxCart.updateView() only ever replaces
   .ajax-cart__list and .ajax-cart__details-wrapper — a container anywhere
   else is injected once at page load (with the cart state of that moment)
   and never again. It must NOT live in .ajax-cart__details-wrapper: that
   wrapper is the sticky checkout footer (stock custom CSS pins it), and
   the rail would inflate the pinned region. (Owner cart spec 2026-10-21:
   rail above the items, collapsible with header previews, compact cards.)
   Render state is stamped on the box element itself (data-eb-sig), so a
   freshly injected box always re-renders and a surviving box never
   re-renders the same cart twice.
   The rail is a sliding slideshow: transform-based track, prev/next
   arrows, touch swipe, and auto-advance that pauses while the drawer is
   closed, the tab is hidden, the user is interacting, or the user prefers
   reduced motion.
   Sibling identity comes from the precomputed map assets
   (assets/eb-sibling-map-1..8.js -> window.EB_SIBLING_MAP, keyed by
   product id), lazy-loaded in parallel only when a [data-eb-funnel]
   container exists. Variant data is fetched live per sibling from
   /products/<handle>.js; if that fetch fails, the card degrades to
   image/title/price linking to the product page.
   Cards reuse the [data-eb-qo] markup contract powered by
   assets/eb-quick-order.js.
   Fix pass 2026-10-21 run 2 (owner): (a) the observer now watches
   document.body - the theme renders the ajax-cart drawer TWICE per page
   (layout/theme.liquid + the mobile-header snippet) and jsAjaxCart
   rewrites both, so watching only the first [data-ajax-cart-drawer]
   coupled the rail to DOM order; (b) sync() no longer drops a refresh
   that arrives while a sync is in flight (dirty-flag re-run), and the
   ensureMap callback re-queries the LIVE boxes instead of the list
   captured before the async map load; (c) a failed sibling-map load no
   longer disables the rail for the whole page session (retry after a
   cooldown); (d) a throttled watchdog re-syncs any OPEN drawer whose
   rail is still hidden and empty. */
(function () {
  'use strict';

  var mapState = 0; /* 0 = not requested, 1 = loading, 2 = ready, 3 = failed */
  var mapFailAt = 0; /* when the last map load failed (ms epoch) */
  var syncing = false;
  var syncDirty = false; /* a refresh was requested while a sync was running */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var AUTO_MS = 5000;
  var collapsedPref = false; /* shopper's collapse choice, kept across drawer re-renders */

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureMap(box, cb) {
    if (mapState === 2) { cb(true); return; }
    if (mapState === 3 && Date.now() - mapFailAt < 8000) { cb(false); return; }
    if (mapState === 3) { mapState = 0; /* transient failure: retry instead of disabling the rail for the whole page session */ }
    if (mapState === 1) {
      var t = setInterval(function () {
        if (mapState === 2) { clearInterval(t); cb(true); }
        if (mapState === 3) { clearInterval(t); cb(false); }
      }, 150);
      setTimeout(function () { clearInterval(t); }, 10000);
      return;
    }
    mapState = 1;
    var base = box.getAttribute('data-map-url');
    var count = parseInt(box.getAttribute('data-map-parts'), 10) || 1;
    var jobs = [];
    for (var n = 1; n <= count; n++) {
      jobs.push(loadScript(base.replace('eb-sibling-map-1', 'eb-sibling-map-' + n)));
    }
    Promise.all(jobs).then(function () {
      mapState = 2;
      cb(!!window.EB_SIBLING_MAP);
    }).catch(function () {
      mapState = 3;
      mapFailAt = Date.now();
      cb(false);
    });
  }

  function cardHTML(sib, productJs) {
    var img = '';
    if (sib.im) img = sib.im + '?width=300';
    var h = '<div class="eb-funnel__card">';
    h += '<a class="eb-funnel__imglink" href="/products/' + esc(sib.h) + '">';
    if (img) h += '<img src="' + esc(img) + '" alt="' + esc(sib.t) + '" loading="lazy">';
    h += '</a>';
    h += '<a class="eb-funnel__name" href="/products/' + esc(sib.h) + '">' + esc(sib.t) + '</a>';
    h += '<div class="eb-funnel__price">' + money(sib.p) + '</div>';
    if (productJs) {
      var variants = productJs.variants.map(function (v) {
        return { i: v.id, o: v.options, a: !!v.available, p: v.price };
      });
      var onlyDefault = productJs.options.length === 1 && productJs.options[0].name === 'Title';
      h += '<div class="eb-qo" data-eb-qo>';
      if (!onlyDefault) {
        productJs.options.forEach(function (opt, idx) {
          h += '<label class="eb-qo__label"><span class="eb-qo__label-text">' + esc(opt.name) + '</span>';
          h += '<select class="eb-qo__select" data-eb-qo-select data-option-index="' + idx + '" aria-label="' + esc(opt.name) + '">';
          h += '<option value="">Select ' + esc(String(opt.name).replace(/^Select\s+/, '')) + '</option>';
          opt.values.forEach(function (val) {
            h += '<option value="' + esc(val) + '">' + esc(val) + '</option>';
          });
          h += '</select></label>';
        });
      }
      h += '<script type="application/json" data-eb-qo-variants>' + JSON.stringify(variants) + '<\/script>';
      h += '<button type="button" class="eb-qo__add button" data-eb-qo-add disabled>Add to Cart</button>';
      h += '<p class="eb-qo__msg" data-eb-qo-msg hidden></p>';
      h += '</div>';
    }
    h += '</div>';
    return h;
  }

  /* ---------------- slider ---------------- */

  function sliderMetrics(box) {
    var track = box.querySelector('[data-eb-funnel-rail]');
    var viewport = box.querySelector('[data-eb-funnel-viewport]');
    var cards = track ? track.children.length : 0;
    var first = track && track.children[0];
    var step = first ? first.offsetWidth + 8 : 176; /* fallback matches the v6 set-size tiles: 168px card + 8px gap */
    var visible = viewport ? Math.max(1, Math.floor((viewport.clientWidth + 10) / step)) : 1;
    return { track: track, viewport: viewport, cards: cards, step: step, max: Math.max(0, cards - visible) };
  }

  function sliderGo(box, idx, manual) {
    var st = box._ebSlider;
    if (!st) return;
    var m = sliderMetrics(box);
    if (m.max <= 0) { st.index = 0; }
    else if (idx > m.max) { st.index = 0; }
    else if (idx < 0) { st.index = m.max; }
    else { st.index = idx; }
    if (m.track) m.track.style.transform = 'translateX(' + (-st.index * m.step) + 'px)';
    if (manual) st.pauseUntil = Date.now() + 12000;
    st.lastAdvance = Date.now();
  }

  function applyCollapsed(box) {
    box.classList.toggle('eb-funnel--collapsed', collapsedPref);
    var t = box.querySelector('[data-eb-funnel-toggle]');
    if (t) t.setAttribute('aria-expanded', collapsedPref ? 'false' : 'true');
  }

  function bindChrome(box) {
    if (box._ebChrome) return;
    box._ebChrome = true;
    var t = box.querySelector('[data-eb-funnel-toggle]');
    if (t) t.addEventListener('click', function () {
      collapsedPref = !collapsedPref;
      document.querySelectorAll('[data-eb-funnel]').forEach(applyCollapsed);
    });
    applyCollapsed(box);
  }

  function sliderBind(box) {
    bindChrome(box);
    if (box._ebSlider) return;
    var st = box._ebSlider = { index: 0, pauseUntil: 0, lastAdvance: Date.now(), touchX: 0, touchY: 0 };
    var prev = box.querySelector('[data-eb-funnel-prev]');
    var next = box.querySelector('[data-eb-funnel-next]');
    if (prev) prev.addEventListener('click', function () { sliderGo(box, st.index - 1, true); });
    if (next) next.addEventListener('click', function () { sliderGo(box, st.index + 1, true); });
    var viewport = box.querySelector('[data-eb-funnel-viewport]');
    if (viewport) {
      viewport.addEventListener('mouseenter', function () { st.hover = true; });
      viewport.addEventListener('mouseleave', function () { st.hover = false; });
      viewport.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        st.touchX = t.clientX; st.touchY = t.clientY; st.hover = true;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        st.hover = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - st.touchX;
        var dy = t.clientY - st.touchY;
        if (Math.abs(dx) > 48 && Math.abs(dx) > 1.4 * Math.abs(dy)) {
          e.preventDefault();
          sliderGo(box, st.index + (dx < 0 ? 1 : -1), true);
        }
      }, { passive: false });
      /* Owner rule: the slide stalls while the shopper is interacting —
         touching, choosing a color/size, or tabbing through the card.
         Any interaction holds the auto-advance; it resumes seconds after
         the last one. */
      ['pointerdown', 'focusin', 'change'].forEach(function (ev) {
        viewport.addEventListener(ev, function () { st.pauseUntil = Date.now() + 10000; }, true);
      });
      ['pointerup', 'focusout'].forEach(function (ev) {
        viewport.addEventListener(ev, function () { st.pauseUntil = Date.now() + 8000; }, true);
      });
    }
  }

  function sliderRefresh(box) {
    sliderBind(box);
    var m = sliderMetrics(box);
    var prev = box.querySelector('[data-eb-funnel-prev]');
    var next = box.querySelector('[data-eb-funnel-next]');
    if (prev) prev.hidden = m.max <= 0;
    if (next) next.hidden = m.max <= 0;
    sliderGo(box, box._ebSlider.index || 0, false);
  }

  /* One global ticker advances every live rail that is due; boxes removed
     by a drawer re-render simply stop being visited. */
  setInterval(function () {
    if (REDUCED || document.visibilityState !== 'visible') return;
    var boxes = document.querySelectorAll('[data-eb-funnel]');
    boxes.forEach(function (box) {
      var st = box._ebSlider;
      if (!st || box.hidden || box.classList.contains('eb-funnel--collapsed') || st.hover || Date.now() < st.pauseUntil) return;
      if (Date.now() - st.lastAdvance < AUTO_MS) return;
      var drawer = box.closest('[data-ajax-cart-drawer]');
      if (drawer && !drawer.classList.contains('is-visible')) return;
      if (sliderMetrics(box).max <= 0) return;
      sliderGo(box, st.index + 1, false);
    });
  }, 1000);

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-eb-funnel]').forEach(function (box) {
      if (box._ebSlider) sliderRefresh(box);
    });
  });

  /* Safety net (same pattern as the slideshow autoplay watchdog): if an
     OPEN drawer ever holds a funnel box that is still hidden with an
     empty rail - a refresh trigger was missed somewhere - re-run a sync.
     Throttled per box so a cart with no siblings costs one cart fetch
     per 8s at most, and only while the shopper is looking at the drawer. */
  setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll('[data-eb-funnel]').forEach(function (box) {
      if (!box.hidden) return;
      var track = box.querySelector('[data-eb-funnel-rail]');
      if (!track || track.children.length) return;
      var drawer = box.closest('[data-ajax-cart-drawer]');
      if (!drawer || !drawer.classList.contains('is-visible')) return;
      var now = Date.now();
      if (box._ebWatchAt && now - box._ebWatchAt < 8000) return;
      box._ebWatchAt = now;
      schedule();
    });
  }, 1500);

  /* ---------------- render + sync ---------------- */

  function renderSiblings(box, sibs, sig) {
    box.setAttribute('data-eb-sig', sig);
    var track = box.querySelector('[data-eb-funnel-rail]');
    var jobs = sibs.map(function (sib) {
      return fetch('/products/' + sib.h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (pjs) { return cardHTML(sib, pjs); });
    });
    Promise.all(jobs).then(function (cards) {
      if (box.getAttribute('data-eb-sig') !== sig || !document.contains(box)) { schedule(); return; } /* box was swapped mid-flight: re-sync against the live drawer */
      track.innerHTML = cards.join('');
      var prev = box.querySelector('[data-eb-funnel-previews]');
      if (prev) {
        prev.innerHTML = sibs.slice(0, 4).map(function (sb) {
          return sb.im ? '<img src="' + esc(sb.im + '?width=56') + '" alt="" loading="lazy">' : '';
        }).join('');
      }
      box.hidden = false;
      sliderRefresh(box);
      applyCollapsed(box);
      if (window.EBQuickOrder) window.EBQuickOrder.refreshAll(box);
    });
  }

  function clearBox(box) {
    box.removeAttribute('data-eb-sig');
    var track = box.querySelector('[data-eb-funnel-rail]');
    var prev = box.querySelector('[data-eb-funnel-previews]');
    if (prev) prev.innerHTML = '';
    if (track) track.innerHTML = '';
    box.hidden = true;
    delete box._ebSlider;
  }

  function sync() {
    var boxes = document.querySelectorAll('[data-eb-funnel]');
    if (!boxes.length) return;
    if (syncing) { syncDirty = true; return; } /* never drop a refresh: re-run once the current sync settles */
    syncing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) {
          boxes.forEach(clearBox);
          return;
        }
        ensureMap(boxes[0], function (ok) {
          if (!ok) return; /* leave boxes unstamped: a later sync retries */
          /* The drawer can be re-rendered while the map loads (page-load
             injection, updateView): render into the LIVE boxes, not the
             list captured when this sync started. */
          boxes = document.querySelectorAll('[data-eb-funnel]');
          if (!boxes.length) return;
          var map = window.EB_SIBLING_MAP || {};
          /* Owner spec 2026-10-21: the strip carries the FULL sibling
             family of EVERY cart item - the union across all root part
             number groupings, deduped by product. A family member that is
             already in the cart is not re-suggested (the map never lists
             an item as its own sibling; this extends that no-self rule
             to multi-item carts). */
          var inCart = {};
          items.forEach(function (it) { inCart[String(it.product_id)] = 1; });
          var seen = {};
          var anchors = [];
          var sibs = [];
          items.forEach(function (it) {
            var entry = map[String(it.product_id)];
            if (!entry || !entry.length) return;
            anchors.push(String(it.product_id));
            entry.forEach(function (sb) {
              var id = String(sb.i);
              if (seen[id] || inCart[id]) return;
              seen[id] = 1;
              sibs.push(sb);
            });
          });
          if (!sibs.length) {
            boxes.forEach(clearBox);
            return;
          }
          var sig = anchors.sort().join(',') + '|' + sibs.map(function (x) { return x.i; }).join(',');
          boxes.forEach(function (box) {
            var track = box.querySelector('[data-eb-funnel-rail]');
            if (box.getAttribute('data-eb-sig') === sig && track && track.children.length) {
              box.hidden = false;
              return;
            }
            renderSiblings(box, sibs, sig);
          });
        });
      })
      .catch(function () { /* drawer stays as-is on any failure */ })
      .then(function () {
        syncing = false;
        if (syncDirty) { syncDirty = false; schedule(); }
      });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; sync(); }, 250);
  }

  function init() {
    /* Observe the whole body, not just the first [data-ajax-cart-drawer]:
       the theme renders the drawer TWICE on every page
       (layout/theme.liquid and snippets/mobile-header.liquid) and
       jsAjaxCart rewrites both instances; watching only the first one
       coupled the rail to whichever instance sits first in DOM order. */
    var target = document.body || document.querySelector('[data-ajax-cart-drawer]') || document.documentElement;
    var obs = new MutationObserver(schedule);
    obs.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ajax-cart-trigger]')) schedule();
    });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.EBFunnel = { sync: sync };
})();
